import { Button, OverlayTrigger } from "react-bootstrap";
import { withTranslation, useTranslation } from "react-i18next";
import { BsCheckLg } from "react-icons/bs";
import ImplementationGuideService from "../../../core/service/ImplementationGuideService";
import { LoaderContext } from "../../../App";
import { useContext, useEffect, useState } from "react";
import moment from "moment";
import Utils from "../../../core/utilities/Utils";
import "./ProfileSettings.scss";
import { useNavigate } from "react-router-dom";
import QuestionService from "../../../core/service/QuestionService";
import useHasPermission from "../../../core/hooks/useHasPermission";


const ImplementationGuide = ({ t, displayedFor = 'COMPANY_SETTINGS', onNavigateTab }) => {

	const navigate = useNavigate();
	const { setLoaderDisplay } = useContext(LoaderContext);
	const [steps, setSteps] = useState([]);
	const [expandedStep, setExpandedStep] = useState(null);
	const { k, i18n } = useTranslation();
	const { hasSettingsUpdatePermission } = useHasPermission();
	useEffect(() => {
		getSteps();
	}, []);

	const getSteps = () => {
		setLoaderDisplay(true);
		ImplementationGuideService.getSteps().then(res => {
			setLoaderDisplay(false);
			if (res.status !== 200) return;			
			setSteps(res.data);

		}).catch(err => {
			setLoaderDisplay(false);
		});
	};

	const handleStepClick = (stepId) => {
		if (expandedStep === stepId) {
			setExpandedStep(null);
		} else {
			setExpandedStep(stepId);
		}
	};

	const renderStatus = (item, displayedFor = 'COMPANY_SETTINGS') => {
		if (item.code === 'DEF_PURPOSE' || item.parentCode === 'DEF_PURPOSE') {
			let tabKey = 'Companydetails';
			if (item.code === 'COMP_DETAILS') {
				tabKey = 'Companydetails';
			} else if (item.code === 'EP_STRUCT') {
				tabKey = 'epStruct';
			} else if (item.code === 'EP_GROUPS') {
				tabKey = 'epGroup';
			}

			if (displayedFor === 'HOME') {
				return <Button variant="primary" className="px-3 py-1" hidden={!hasSettingsUpdatePermission()} onClick={() => navigate('/company_admin/company_settings', { state: { tabKey } })}>
					{item.status === 'IN_PROGRESS' ? t("Resume.label") : item.status === 'NOT_STARTED' ? t("Start.label") : t("View.label")}
				</Button>;
			} else {
				return <Button variant="primary" className="px-3 py-1" hidden={!hasSettingsUpdatePermission()} onClick={() => onNavigateTab(tabKey)}>
					{item.status === 'IN_PROGRESS' ? t("Resume.label") : item.status === 'NOT_STARTED' ? t("Start.label") : t("View.label")}
				</Button>;
			}

		} else if (item.code === 'MAT_ASSESS' || item.parentCode === 'MAT_ASSESS') {
			let route = '/company_admin/dmat/stats';
			if (item.code === 'ID_MAT_ISSUES') {
				route = '/company_admin/dmat/issues';
			} else if (item.code === 'STAKE_MAP') {
				route = '/company_admin/dmat/stakeholders';
			} else if (item.code === 'MAT_ASSESS_SUB') {
				route = '/company_admin/dmat/matassessments';
			} else if (item.code === 'MAT_REPORT') {
				route = '/company_admin/dmat/report/list';
			}

			return <Button variant="primary" className="px-3 py-1" hidden={!hasSettingsUpdatePermission()} onClick={() => navigate(route)}>
				{item.status === 'IN_PROGRESS' ? t("Resume.label") : item.status === 'NOT_STARTED' ? t("Start.label") : t("View.label")}
			</Button>;
		}
	};

	const renderStatusBadge = (item) => {
		if (item.status === 'IN_PROGRESS') {
			return (
				<span className="badge bg-badge-Inprogress rounded-pill py-1">
					{t('InProgress.label')}
				</span>
			);
		} else if (item.status === 'COMPLETED') {
			return (
				<span className="badge bg-badge-Finalized rounded-pill py-1">
					{t('Completed.label')}
				</span>
			);
		} else if (item.status === 'NOT_STARTED') {
			return (
				<span className="badge bg-badge-New rounded-pill py-1">
					{t('NotStarted.label')}
				</span>
			);
		}
		// Return null if none of the conditions are met
		return null;
	};

	const renderGuide = () => {
		return (
			<div className="Implementation_GuideCard mt-3">
				<div className="GuideCard_Stepshead mb-1">
					<div className="row m-0  align-items-center">
						<div className="col-md-4 col-sm-4 p-1">
							<h6 className="m-0 text-secondary">{t("Steps.label")}</h6>
						</div>

						<div className="col-md-2 col-sm-2 p-2">
							<h6 className="m-0 text-secondary">{t("Status.label")}</h6>
						</div>
						{
							displayedFor === 'HOME' &&
							<>
								<div className="col-md-4 col-sm-4 p-1">
									<h6 className="m-0 text-secondary">{t("UpdatedOn.label")}</h6>
								</div>
								<div className="col-md-2 col-sm-2 p-1">

								</div>
							</>
						}
						{
							displayedFor === 'COMPANY_SETTINGS' &&
							<>
								<div className="col-md-2 col-sm-2 p-1">
									<h6 className="m-0 text-secondary">{t("UpdatedOn.label")}</h6>
								</div>
								<div className="col-md-2 col-sm-2 p-1">
									<h6 className="m-0 text-secondary">{t("UpdatedBy.label")}</h6>
								</div>
								<div className="col-md-2 col-sm-2 p-1">
									
								</div>
							</>
						}
					</div>
				</div>

				{
					steps?.map((step, index) => (
						<div className="card GuideCard_Steps shadow-sm 1" key={step.id}>
							<div className="progress_line">
								<span className={
									step.status === 'COMPLETED'
										? 'bgBox bg-success'
										: step.status === 'IN_PROGRESS'
											? 'border-success'
											: 'default'
								}>
								</span>
								{/* <span style={{
                                backgroundColor: step.status === 'COMPLETED' ? '#00bc07' : step.status === 'IN_PROGRESS' ? '#f99c35' : ''
                            }}></span> */}
							</div>
							<div className="row m-0 align-items-center">
								{
									step.subSteps.length > 0 ? (
										<OverlayTrigger placement="top" overlay={Utils.renderTooltip(t('ViewSubSteps.label'))}>
											<div className="col-md-4 col-sm-4 p-2 "
												onClick={() => handleStepClick(step.id)}>
												<h6 className="m-0 cursor">{index + 1}. {step.name}</h6>
												{/* {
													displayedFor === 'HOME' &&
													<div>
														{step.lastModifiedDate ? moment(step.lastModifiedDate).format("DD MMM YYYY, h:mm A") : ''}
													</div>
												} */}
											</div>
										</OverlayTrigger>
									) : (
										<div className="col-md-4 col-sm-4 p-2">
											<h6 className="m-0">{index + 1}. {step.name}</h6>
										</div>
									)
								}

								<div className="col-md-2 col-sm-2 p-2">
									{renderStatusBadge(step)}
								</div>
								{
									displayedFor === 'HOME' &&
									<>
										<div className="col-md-4 col-sm-4 p-2">
											{step.lastModifiedDate ? moment(step.lastModifiedDate).format("DD MMM YYYY, h:mm A") : ''}
										</div>
										<div className="col-md-2 col-sm-2 p-2">
											{renderStatus(step, displayedFor)}
										</div>
									</>
								}
								{
									displayedFor === 'COMPANY_SETTINGS' &&
									<>
										<div className="col-md-2 col-sm-2 p-2">
											{step.lastModifiedDate ? moment(step.lastModifiedDate).format("DD MMM YYYY, h:mm A") : ''}
										</div>
										<div className="col-md-2 col-sm-2 p-2">
											{step.lastModifiedBy ? step.lastModifiedBy : ''}
										</div>
										<div className="col-md-2 col-sm-2 p-2">
											{renderStatus(step)}
										</div>
									</>
								}
							</div>

							{
								expandedStep === step.id && step.subSteps.length > 0 && (
									<div className="GuideCard_Steps_body">
										{
											step.subSteps.map((subStep) => (
												<div className="row m-0 align-items-center" key={subStep.id}>
													<div className="col-md-4 py-1 GUidestepsName">
														<span className="me-2  text-success completeCheck">
															{subStep.status === "COMPLETED" && <BsCheckLg />}
														</span>
														{subStep.name}
													</div>
													<div className="col-md-2 p-2">
														{renderStatusBadge(subStep)}
													</div>
													{
														displayedFor === 'HOME' &&
														<>
															<div className="col-md-4 px-2 py-1">
																{subStep.lastModifiedDate ? moment(subStep.lastModifiedDate).format("DD MMM YYYY, h:mm A") : ''}
															</div>
															<div className="col-md-2 p-2">
																{renderStatus(subStep, displayedFor)}
															</div>
														</>
													}

													{
														displayedFor === 'COMPANY_SETTINGS' &&
														<>
															<div className="col-md-2 p-2">
																{subStep.lastModifiedDate ? moment(subStep.lastModifiedDate).format("DD MMM YYYY, h:mm A") : ''}
															</div>
															<div className="col-md-2 p-2">
																{subStep.lastModifiedBy}
															</div>
															<div className="col-md-2 p-2">
																{renderStatus(subStep)}
															</div>
														</>
													}
												</div>
											))
										}
									</div>
								)
							}
						</div>
					))
				}
			</div >
		);
	};

	return (
		<>
			{
				displayedFor === 'HOME'
					?
					<div className="HomeCard mb-3">
						<div className="HomeCardhead">
							<div className="HomeCardhead_in">
								<h5>{t('ImplementationGuide.label')}</h5>
							</div>
							{
								steps?.filter(s => s.status === 'COMPLETED')?.length !== steps.length &&
								<p className="text-muted mb-0">{t("ImplementationProcessInProgress.label")}</p>
							}
						</div>
						<div className="HomeCardBody border-bottom">{renderGuide()}</div>
					</div>
					:
					renderGuide()
			}
		</>
	);
}

export default withTranslation()(ImplementationGuide);